export function throttle(func, timeFrame) {
    let lastTime = 0;
    return function () {
        const now = new Date().valueOf();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}
//# sourceMappingURL=throttle.js.map
